import alt from 'components/Dispatcher';

class LibraryActions {
  constructor() {
    this.generateActions(
      'updateLibraryDropdown',
      'addTag',
      'createTag',
      'removeTag',
      'updateSharingTargets',
      'updateSharingValues',
      'updateUserList',
      'clearSearchInfo',
      'resetSearchCriteria',
      'clearCallersAutocomplete',

      'createLibrary',
      'createLibraryLoading',
      'createLibrarySuccess',
      'createLibraryError',

      'getLibraries',
      'getLibrariesLoading',
      'getLibrariesSuccess',
      'getLibrariesError',

      'addFileToLibrary',
      'addFileToLibraryLoading',
      'addFileToLibrarySuccess',
      'addFileToLibraryError',

      'getTags',
      'getTagsLoading',
      'getTagsSuccess',
      'getTagsError',

      'getRecentTags',
      'getRecentTagsLoading',
      'getRecentTagsSuccess',
      'getRecentTagsError',

      'getCommonTags',
      'getCommonTagsLoading',
      'getCommonTagsSuccess',
      'getCommonTagsError',

      'getLibraryTag',
      'getLibraryTagLoading',
      'getLibraryTagSuccess',
      'getLibraryTagError',

      'updateTagToRemove',

      'showCreateOrUpdateLibraryDialog',
      'showCreateOrUpdateLibraryDialogLoading',
      'showCreateOrUpdateLibraryDialogSuccess',
      'showCreateOrUpdateLibraryDialogError',

      'hideCreateOrUpdateLibraryDialog',

      'getShareItems',
      'getShareItemsLoading',
      'getShareItemsSuccess',
      'getShareItemsError',

      'getShareAccessibleDepartments',
      'getShareAccessibleDepartmentsLoading',
      'getShareAccessibleDepartmentsSuccess',
      'getShareAccessibleDepartmentsError',

      'getShareAccessibleTeams',
      'getShareAccessibleTeamsLoading',
      'getShareAccessibleTeamsSuccess',
      'getShareAccessibleTeamsError',

      'getLibrary',
      'getLibraryLoading',
      'getLibrarySuccess',
      'getLibraryError',

      'deleteLibrary',
      'deleteLibraryLoading',
      'deleteLibrarySuccess',
      'deleteLibraryError',

      'deleteLibraryTag',
      'deleteLibraryTagLoading',
      'deleteLibraryTagSuccess',
      'deleteLibraryTagError',

      'updateLibrary',
      'updateLibraryLoading',
      'updateLibrarySuccess',
      'updateLibraryError',

      'updateCurrentLibrary',
      'updateCurrentTags',
      'updateCurrentCallers',

      'getCallersAutocomplete',
      'getCallersAutocompleteLoading',
      'getCallersAutocompleteSuccess',
      'getCallersAutocompleteError',

      'searchCalls',
      'searchCallsLoading',
      'searchCallsSuccess',
      'searchCallsError',

      'searchMostRecentlyAdded',
      'searchMostRecentlyAddedLoading',
      'searchMostRecentlyAddedSuccess',
      'searchMostRecentlyAddedError',

      'searchTag',
      'searchTagLoading',
      'searchTagSuccess',
      'searchTagError',

      'searchLibrary',
      'searchLibraryLoading',
      'searchLibrarySuccess',
      'searchLibraryError',

      'updateLibrarySearchType',
      'updateSearchingCalls',
      'changeLibraryPage',
      'updateCurrentOpenDialog',

      'getInfoAboutFiles',
      'getInfoAboutFilesLoading',
      'getInfoAboutFilesSuccess',
      'getInfoAboutFilesError',

      'getFileInfo',
      'getFileInfoLoading',
      'getFileInfoSuccess',
      'getFileInfoError',

      'reinitLibrarySearchContext',
      'updateLibraryTagToDelete',

      'fetchLibraryHighlights',
      'fetchLibraryHighlightsSuccess',
      'fetchLibraryHighlightsError',

      'addLibraryHighlight',
      'addLibraryHighlightSuccess',
      'addLibraryHighlightError',

      'removeLibraryHighlight',
      'removeLibraryHighlightSuccess',
      'removeLibraryHighlightError'
    );
  }
}

export default alt.createActions(LibraryActions);
